import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,{attrs:{"id":"gameContainer"}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('progress-bar'),_c('word-input',{on:{"requestChecking":function($event){return _vm.checkGuess()}}}),_c('toolbar'),_c('keyboard',{on:{"requestChecking":function($event){return _vm.checkGuess()}}}),_c('clock')],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('list')],1),_c('snackbar')],1),_c('modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }